<template>
  <div class="goodModification" :v-loading="loading">
    <el-table class="list" v-loading="loading"
              header-row-class-name="table-header"
              :ref="defaultTableOptions.tableName"
              :data="tableData"
              @selection-change="handleSelectionChange"
              :header-row-style="{height:'28px',lineHeight:'28px'}"
              @row-click="rowClick" row-key="id"
              @select="rowSelect" @select-all="rowSelect">
      {{batchUpData}}
      <!--多选-->
      <el-table-column v-if="isSelect" type="selection" width="55"></el-table-column>
      <!--索引-->
      <el-table-column
        align="center"
        type="index"
        width="60"
        label="序号"
      ></el-table-column>
      <el-table-column
        v-for="(column,index) in (tableOptions.columns||defaultTableOptions.columns)"
        :key="index"
        :class-name="column.class"
        :property="column.prop"
        :label="column.label"
        :align="column.align ||tableOptions.align||defaultTableOptions.align"
        :min-width="column.width || tableOptions.width||defaultTableOptions.width"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <div v-show="scope.$index < tableData.length" :style="{height:'30px',lineHeight:'30px'}">
            <span v-if="column.type =='index'">{{ scope.$index + 1 }}</span>
            <!--输入框-->
            <el-input autocomplete="off" v-if="column.type === columnType.input"
                      v-model="scope.row[column.prop]"
                      :maxlength=4 :minlength="column.minlength"
                      :placeholder="column.placeholder"
                      :disabled="column.disabled"></el-input>
            <div v-else-if="column.enumData" v-html="$utils.getEnumItem(column,scope.row[column.prop])"></div>
            <span v-else>{{ scope.row[column.prop] }}</span>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
  import searchFormTemplate from '../template/searchFormTemplate';
  import tableTemplate from '../template/tableTemplate';
  import api from '@/config/api';

  export default {
    props: {
      isSelect: {
        type: Boolean,
        default: () => {
          return false;
        }
      },
      tableOptions: {
        type: Object,
        default: () => {
          return {};
        }
      },
      batchUpData: {
        type: Array,
        default: () => {
          return [];
        }
      },
    },
    components: {tableTemplate, searchFormTemplate},
    data() {
      return {
        columnType: this.$utils.columnType,
        loading: false,
        // 表格信息配置
        defaultTableOptions: {
          tableName: 'goodsTable',
          indexShow: true,//是否显示索引
          indexMethod: (index) => {//自定义列索引
            return index + 1;
          },
          columns: [
            {
              label: '条码',
              prop: 'barCode',
              width: '150',
              align: 'center'
            },
            {
              label: "品名",
              prop: "goodsName",
              width: "100",
              align: "center"
            },
            {
              label: "PLU码",
              prop: "pluCode",
              width: "100",
              align: "center",
              type: "input"
            },
          ],
          url: api.archives.goodsInfo
        },
        tableData: [],
      }
    },
    mounted() {
      this.getTableData();
    },
    methods: {
      valueChange(column, row, index) {
        this.$forceUpdate();
        column.change && column.change(row, index);
      },
      selectSubmit() {
        this.clearSelection();
        this.$emit('selectSubmit', this.tabelSelectRows);
      },
      rowSelect(selection) {
        this.tabelSelectRows = selection;
      },
      searchSubmit(param) {
        this.getTableData(param);
      },
      rowClick(row, column, event) {
        if (this.isSelect) return;
        this.$emit('rowCheck', row);
      },
      handleSizeChange(pageSize) {
        this.page.pageSize = pageSize;
        this.page.current = 1;
        this.getTableData();
      },
      //清除选中
      clearSelection() {
        this.$refs[this.defaultTableOptions.tableName].clearSelection();
      },
      //选中项
      handleSelectionChange(val) {
        this.selectRow = val;
      },
      // 翻页
      handleCurrentChange(value) {
        this.page.current = value;
        this.getTableData();
      },
      // 获取表格数据
      getTableData(param) {
        this.tableData = this.batchUpData;
      },
    }
  }
</script>
<style scoped>
  .goodModification {
    height: 410px;
    overflow-y: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/business/batchUpdatePLU.vue